import ExerciseCard from "./ExerciseCard";

export default function ExerciseList({ searchedExercise }) {
  console.log(searchedExercise);
  return (
    <section className="mt-10 py-14 w-[80%] mx-auto">
      <div className="grid md:grid-cols-2 lg:grid-cols-3  gap-x-8 gap-y-14  items-center justify-center">
        {searchedExercise?.map((data, index) => {
          return <ExerciseCard workout={data} key={index} />;
        })}
      </div>
    </section>
  );
}
